import React from "react";
import { Tabs } from "antd";

const TabUi = ({ tabId, setTabId }) => {
    return (
        <Tabs
            className="mx-2 text-base"
            popupClassName="mb-0"
            tabBarStyle={{
                marginBottom: 0,
            }}
            activeKey={tabId}
            defaultActiveKey={tabId}
            items={[
                { label: "All documents", key: "all_documents" },
                { label: "New", key: "new_documents" },
                { label: "Pending", key: "pending_documents" },
            ]}
            onChange={(value) => {
                setTabId(value);
            }}
        />
    );
};

export default TabUi; 